var _circle, _circle2, _circle3, _circle4, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessfullicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#C4FFCD",
    fillOpacity: 0.46
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#C4FFCD",
    fillOpacity: 0.46
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30,
    r: 24,
    fill: "#C4FFCD",
    fillOpacity: 0.46
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30,
    r: 24,
    fill: "#2E7D32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 15,
    width: 30,
    height: 30,
    fill: "url(#pattern0_3613_522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3613_522",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3613_522",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3613_522",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABdklEQVR4nO2WzUrDQBRGg8VV99aF0ILbbrQFsQi+guDStr6Kr9Gq76F9gta1PwvBZVNdC8bVkYs3OMbMJJkkuOlZNZ1hDtzc+2WCYE0OgDbwBDwCnaAOgD4wApr63ABm/CC/G7rW1L29stJt4FMFIXANLPiL/Hele4QIaJURD/BnUEY8LiEe+ZT3ADgHViXEKz2jn1l23RS/0yqJgH2XWDqyLoYusYzDsgZpGI+jS37pefirzC9wlLI2zZJKONx5SrtGn6TNecMm7SQSyUfa1ec0Zqnxqtlr4xQ4Ad49pTEPaWIJfBu7uufYkBeVWsVtR6mfgR1D/uIhvRWHq7kWOeSbBaVza3PlHCdTnlcqTLKkeQJEynwBvJGfpTNAao7MM5e4p4FeNR/AXla5W5o+45KfxVArKGdtOaX/ehGo8OpzGPjC920kMko30ZlMMte10HinxcqbRG4O0pGJ662kUMwNsGGM4zCzkXzRL5lk+701BtcEv/kCS7d9YnRFL8cAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfullicon);
export default __webpack_public_path__ + "static/media/successfull icon.39f4c5cf6784b86aae2dcd7b04c7ab56.svg";
export { ForwardRef as ReactComponent };